module.exports = __webpack_public_path__ + "img/inaes_branco.281759dc.png";